module.exports = __webpack_public_path__ + "img/newchris-74.d256345d.jpg";